import React from 'react';
import { TextField } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const styles = {
    textField: {
        margin: 20
    },
    searchContainer: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    hidePaidInvoices: {
        marginTop: '4px'
    }
}

export default function SearchByDate(props) {    
    return (
        <div style={styles.searchContainer}>
            <TextField
                label="From Date"
                id='fromDate'
                InputLabelProps={{ shrink: true, }}
                style={styles.textField}
                onChange={(e) => props.setFromDate(e.target.value)}
                type="date" />
            <TextField
                label="To Date"
                id='toDate'
                InputLabelProps={{ shrink: true, }}
                style={styles.textField}
                onChange={(e) => props.setToDate(e.target.value)}
                type="date" />
            <FormControlLabel
                id="unpaidFilter"
                label="Hide Paid Invoices"
                style={styles.hidePaidInvoices}
                control={
                    <Checkbox onChange={event => props.onFilterChanged(event.target.checked)} />
                }
            />
        </div>
    );
    
}